import { Lightbulb } from 'lucide-react'
import { AsideCard } from './aside-card'

/**
 * Beside the Goals step: how to answer three open-ended questions well.
 * This is the coaching card the superseded `TipsCard` used to render from
 * step data — now plain JSX on the one page that has it, because no second
 * page wants this exact shape.
 */
export function GoalsAside() {
  return (
    <AsideCard>
      <h2 className="flex items-center gap-2 font-medium text-sm">
        <Lightbulb aria-hidden="true" className="size-4 text-primary" />
        How to stand out
      </h2>
      <ul className="mt-3 space-y-2 text-muted-foreground text-sm">
        {[
          'Write it as though it already happened. It is easier to be concrete that way.',
          'Numbers tell us more than adjectives do.',
          'Name real weaknesses. That is what we coach.',
        ].map((item) => (
          <li key={item} className="flex gap-2">
            <span aria-hidden="true">•</span>
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </AsideCard>
  )
}
